import { hasProp } from '@/utils/validate.utils';

const sanitizeStep = compatibility => {
  try {
    const steps = [];

    if (hasProp(compatibility, 'compatibilityType')) {
      steps[0] = {compatibilityType: compatibility.compatibilityType};
    }
    if (hasProp(compatibility, 'articleType')) {
      steps[1] = {articleType: compatibility.articleType};
    }
    if (hasProp(compatibility, 'brand')) {
      steps[2] = {brand: compatibility.brand};
    }
    if (hasProp(compatibility, 'iumodel')) {
      steps[3] = {iumodel: compatibility.iumodel};
    }

    return steps;

  } catch (error) {
    console.log(error);
    return null;
  }
}
export { sanitizeStep };
